import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { CardsApi } from '@shared/api/rest';
import { ApiUtils } from '@shared/utils';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';
import type { CardResponse, CardsRequest } from '@shared/api/rest/cards';

const getCardsEffect = createEffect((params: IQueryParams<CardsRequest>) => CardsApi.getCards(params?.request, params?.signal));
const clearEvent = createEvent();

const $dataStore = createStore<CardResponse[]>([])
  .on(getCardsEffect.done, (current, data) => data.result.data ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(true)
  .on(getCardsEffect.pending, (_, data) => data)
  .on(getCardsEffect.fail, () => false)
  .on(getCardsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getCardsEffect, () => null)
  .on(getCardsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getCardsEffect.done, () => null)
  .reset(clearEvent);

export const $initialCardsStore = {
  events: {
    getCards: ApiUtils.wrapperApi(getCardsEffect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
